import { render, staticRenderFns } from "./backup-history.component.vue?vue&type=template&id=0ee1d5b9"
import script from "./backup-history.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-history.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee1d5b9')) {
      api.createRecord('0ee1d5b9', component.options)
    } else {
      api.reload('0ee1d5b9', component.options)
    }
    module.hot.accept("./backup-history.component.vue?vue&type=template&id=0ee1d5b9", function () {
      api.rerender('0ee1d5b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/backup-settings/backup-history.component.vue"
export default component.exports